import React, { useEffect, useState } from "react";
import "./CSS/connectionStatus.css";
import axios from "axios";

const ConnectionStatus = () => {
  const [connectionData, setConnectionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);

  // Company names mapping
  const companyNames = {
    1: "Akra V",
    3: "Crowne Plaza",
    4: "Akra Antalya"
  };

  // Fetch connection status from API
  const fetchConnectionStatus = async () => {
    try {
      setLoading(true);
      const apiUrl = "https://app-rmms-engine.azurewebsites.net/api/Task/connectionmonitor/status/1";
      console.log("🔥 Fetching from:", apiUrl);
      const response = await axios.get(apiUrl);
      console.log("🔥 Response data:", response.data);
      setConnectionData(response.data);
      setLastUpdate(new Date());
      setError(null);
    } catch (err) {
      console.error("🔥 Connection status fetch error:", err);
      setError("Bağlantı durumu alınamadı: " + (err.message || "Bilinmeyen hata"));
    } finally {
      setLoading(false);
    }
  };

  // Auto-refresh every minute
  useEffect(() => {
    console.log("🔥 ConnectionStatus useEffect triggered");
    fetchConnectionStatus();
    const interval = setInterval(fetchConnectionStatus, 60000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // LED status indicator
  const StatusLED = ({ status }) => {
    const colorMap = {
      green: "#28a745",
      yellow: "#ffc107",
      red: "#dc3545"
    };

    return (
      <div
        className="status-led"
        style={{
          backgroundColor: colorMap[status] || "#6c757d",
          boxShadow: `0 0 10px ${colorMap[status] || "#6c757d"}`
        }}
      />
    );
  };

  // Format date/time - Convert UTC to local time
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";

    // If already a Date object, use it directly
    let date;
    if (dateString instanceof Date) {
      date = dateString;
    } else {
      // Convert string to Date - ensure the date string is treated as UTC if it doesn't have timezone info
      let utcDate = String(dateString);

      // If string doesn't have timezone info, treat it as UTC
      if (!utcDate.endsWith('Z') && !utcDate.includes('+') && !utcDate.includes('-', 10)) {
        // Replace space with 'T' for ISO format if needed
        if (utcDate.includes(' ') && !utcDate.includes('T')) {
          utcDate = utcDate.replace(' ', 'T');
        }
        // Add 'Z' to indicate UTC
        utcDate = utcDate + 'Z';
      }

      date = new Date(utcDate);
    }

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return "-";
    }

    return date.toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
      // timeZone will automatically use local timezone
    });
  };

  if (loading && !connectionData) {
    return (
      <div className="connection-status-container">
        <div className="loading-message">Yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="connection-status-container">
        <div className="error-message">{error}</div>
        <button onClick={fetchConnectionStatus} className="retry-button">
          Tekrar Dene
        </button>
      </div>
    );
  }

  return (
    <div className="connection-status-container">
      <div className="connection-status-header">
        <h2>Bağlantı Durumu</h2>
        <div className="header-info">
          <span className="last-update">
            Son Güncelleme: {lastUpdate ? formatDateTime(lastUpdate) : "-"}
          </span>
          <button onClick={fetchConnectionStatus} className="refresh-button">
            🔄 Yenile
          </button>
        </div>
      </div>

      <div className="connection-table-wrapper">
        <table className="connection-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Adı</th>
              <th>Durum</th>
              <th>Son Güncelleme</th>
              <th>Son Başarılı Okuma</th>
            </tr>
          </thead>
          <tbody>
            {connectionData && connectionData.companies
              ? connectionData.companies.map((company) => (
                  <tr
                    key={company.companyId}
                    className={company.isHealthy ? "" : "unhealthy-row"}
                  >
                    <td>{company.companyId}</td>
                    <td>{companyNames[company.companyId] || `Şirket ${company.companyId}`}</td>
                    <td>
                      <StatusLED status={company.status} />
                    </td>
                    <td>{formatDateTime(company.lastUpdate)}</td>
                    <td>{company.message ? formatDateTime(company.message.replace('Last update: ', '').replace(' UTC', '')) : '-'}</td>
                  </tr>
                ))
              : <tr><td colSpan="5">Veri bulunamadı</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ConnectionStatus;
